import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-black border-t border-white/10 pt-20 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <span className="relative inline-flex w-9 h-9 items-center justify-center bg-[#E63946]">
                <span className="font-heading font-black text-white text-lg leading-none">
                  M
                </span>
                <span className="absolute -bottom-1 -right-1 w-2 h-2 bg-white"></span>
              </span>
              <span className="font-heading font-black tracking-tighter text-2xl">
                Motorie<span className="text-[#E63946]">Ricambi</span>
              </span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-md mb-6">
              Specialisti in motori usati e revisionati, cambi manuali e
              automatici e musate complete. Oltre {COMPANY.yearsExperience}{" "}
              anni di esperienza al servizio della meccanica.
            </p>
            <div className="inline-flex items-center gap-3 border border-white/10 px-4 py-2.5 bg-[#0e0e0e]">
              <div className="w-2 h-2 bg-[#25D366] rounded-full animate-pulse" />
              <span className="text-xs uppercase tracking-widest font-mono text-zinc-300">
                Disponibili Ora · Risposta in 24h
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] font-mono text-zinc-500 mb-5">
              Navigazione
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-zinc-300 hover:text-[#E63946] transition-colors text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] font-mono text-zinc-500 mb-5">
              Contatti
            </div>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${COMPANY.phoneRaw}`}
                  className="flex items-start gap-3 text-zinc-300 hover:text-white transition-colors"
                >
                  <Phone size={16} className="text-[#E63946] mt-0.5" />
                  <div>
                    <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono mb-0.5">
                      Telefono / WhatsApp
                    </div>
                    <div className="text-sm font-mono">{COMPANY.phone}</div>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="flex items-start gap-3 text-zinc-300 hover:text-white transition-colors"
                >
                  <Mail size={16} className="text-[#E63946] mt-0.5" />
                  <div>
                    <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono mb-0.5">
                      Email
                    </div>
                    <div className="text-sm">{COMPANY.email}</div>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3 text-zinc-300">
                <MapPin size={16} className="text-[#E63946] mt-0.5" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono mb-0.5">
                    Ragione Sociale
                  </div>
                  <div className="text-sm font-bold text-white">B.L. MECCANICA MOTORI</div>
                  <div className="text-xs text-zinc-500 font-mono mt-1">P. IVA 01647660164</div>
                  <div className="text-xs text-zinc-400 mt-1">Spedizioni in tutta Italia</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-zinc-500 font-mono uppercase tracking-widest">
          <div>
            © {new Date().getFullYear()} <strong className="text-zinc-300">B.L. MECCANICA MOTORI</strong> · P. IVA 01647660164 · Tutti i diritti riservati
          </div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
